import i18n from '@/plugins/i18n';
function format(pattern, _object, isColorLable = false, colorCode = '#ffffff') {
  //ffffff
  if (_object.length > 9) {
    throw Error(
      i18n.global.t(
        'the-maximum-number-of-placeholder-characters-supported-is-nine',
      ),
    );
  }
  const a = Array.from(pattern);
  var sb = '';
  var counter = 0;
  var setValue = 0;
  for (const s2 of a) {
    if (s2 === undefined) {
      continue;
    }
    if (s2 === '{') {
      innerloop: for (var i = counter + 1; i < a.length; i++) {
        if (isNaN(a[i])) {
          throw Error('Invalid pattern');
        } else if (a[i] === '}') {
          throw Error('Invalid pattern.');
        } else if (!isNaN(a[i])) {
          if (isColorLable && colorCode) {
            sb +=
              '<span style="' +
              formStyle(colorCode) +
              '">' +
              _object[setValue] +
              '</span>';
          } else sb += _object[setValue];
          setValue++;
          if (a[i + 1] === '}') {
            delete a[i];
            delete a[i + 1];
            counter += 3;
          }
          break innerloop;
        }
      }
    } else {
      sb += s2;
      counter++;
    }
  }
  return sb;
}

function formStyle(_object) {
  var _style = '';
  for (const key in _object) {
    _style += key + ':' + _object[key] + ';';
  }
  return _style;
}

export default format;
